// extracted by mini-css-extract-plugin
module.exports = {"slidesList":"_80d1db09ff6f0c8d04ab0a7e96df443f-less","slideItem":"cab711a14b1a734645716b1bc8e72a40-less"};